var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-white shadow overflow-hidden sm:rounded-lg" },
    [
      _vm.heading
        ? _c(
            "div",
            { staticClass: "px-4 py-5 border-b border-gray-200 sm:px-6" },
            [
              _c(
                "div",
                { staticClass: "flex items-center justify-between" },
                [
                  _c("h4", { staticClass: "text-lg leading-6 text-gray-900" }, [
                    _vm._v(_vm._s(_vm.heading)),
                  ]),
                  _vm._v(" "),
                  _vm._t("header"),
                ],
                2
              ),
              _vm._v(" "),
              _vm.description
                ? _c(
                    "p",
                    {
                      staticClass:
                        "mt-1 max-w-2xl text-sm leading-5 text-gray-500",
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.description) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "px-4 py-5 sm:p-0" }, [
        _c(
          "dl",
          _vm._l(_vm.listItems, function (item) {
            return _c(
              "div",
              {
                staticClass:
                  "sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5 mt-8 first:mt-0 sm:mt-0 first:border-t-0 sm:border-t sm:border-gray-200",
              },
              [
                _c(
                  "dt",
                  {
                    staticClass: "text-sm leading-5 font-medium text-gray-500",
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.name) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("dd", {
                  staticClass:
                    "mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2",
                  domProps: { innerHTML: _vm._s(item.value) },
                }),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }